import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { isEmptyCategoryHref, useCategoryStockVersion } from "@/lib/categoryStock";
import tileUnder100 from "@/assets/collection-table-lamps.webp";
import tile100 from "@/assets/collection-decor.webp";
import tile250 from "@/assets/collection-floor-lamps.webp";
import tileAll from "@/assets/collection-living.webp";

const bands = [
  { label: "Under $100", href: "/category/under-100", img: tileUnder100 },
  { label: "$100 to $250", href: "/category/100-250", img: tile100 },
  { label: "$250 to $600", href: "/category/250-600", img: tile250 },
  // Not "Shop Everything": /category/all lists furniture, lighting and textiles, not the whole catalogue.
  { label: "Shop All Furniture", href: "/category/all", img: tileAll },
];

/** Price-band entry points, styled to match the Shop by Room tiles. */
export const ShopByPrice = () => {
  useCategoryStockVersion();
  const visibleBands = bands.filter((band) => !isEmptyCategoryHref(band.href));

  return (
  <section className="w-[89%] max-w-[1140px] mx-auto pt-5 md:pt-2 pb-3 md:pb-4">
    <div className="flex items-center justify-between gap-3 mb-3">
      <h2 className="text-[12px] md:text-[13px] tracking-[0.14em] md:tracking-[0.22em] uppercase font-bold text-foreground whitespace-nowrap">
        Shop by Price
      </h2>
      <Link
        to="/category/all"
        className="text-[10px] tracking-[0.12em] md:tracking-[0.18em] uppercase font-bold text-foreground hover:text-primary inline-flex items-center gap-1.5 whitespace-nowrap shrink-0"
      >
        Shop all prices <ArrowRight className="h-3 w-3" />
      </Link>
    </div>
    <div className="flex md:grid md:grid-cols-4 gap-3 overflow-x-auto md:overflow-visible snap-x snap-mandatory scrollbar-hide -mx-[5.5%] md:mx-0 px-[5.5%] md:px-0">
      {visibleBands.map((band) => (
        <Link
          key={band.label}
          to={band.href}
          className="group relative block overflow-hidden rounded-md shadow-sm shrink-0 w-[68%] sm:w-[44%] md:w-auto snap-start"
        >
          <img
            src={band.img}
            alt={band.label}
            className="w-full h-[140px] md:h-[130px] object-cover group-hover:scale-105 transition-transform duration-700"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/10 to-transparent" />
          <div className="absolute bottom-3 left-3 right-2 flex items-center justify-between text-primary-foreground">
            <span className="text-[14px] md:text-[13px] font-bold">{band.label}</span>
            <span className="h-8 w-8 rounded-full bg-background/95 text-foreground flex items-center justify-center shadow-sm">
              <ArrowRight className="h-4 w-4" />
            </span>
          </div>
        </Link>
      ))}
    </div>
  </section>
);
};
